import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useCreateCustomerOtpMutation,
  useCustomerLoginMutation,
} from "../slices/customerSlice";
import { useCreateOrderMutation } from "../slices/OrdersSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import { useCheckFoodItemAvailabilityMutation } from "../slices/FoodItemSilce";
import ReUsableModal from "../components/ReUsableModal";
import { setFoodList } from "../slices/foodListSlice";

const FoodAppLoginScreen = () => {
  const { id: outlets } = useParams();
  const [mobileNumber, setMobileNumber] = useState("9876987698");
  const [getOtp, setGetOtp] = useState("1234");
  const [otpSent, setOtpSent] = useState(false);
  const [otpVerified, setOtpVerified] = useState(false);
  const [notAvailableItems, setNotAvailableItems] = useState({});
  const [itemsForModal, setItemsForModal] = useState();
  const [showModal, setShowModal] = useState(false);
  const { userInfo } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [seatNumber, setSeatNumber] = useState("");
  const [screen, setScreen] = useState("");

  const location = useLocation();
  // const {
  //   selectedItems = [],
  //   companyName = "",
  //   outletAddress = "",
  // } = location.state || {};
  const navigate = useNavigate();

  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  const [generateOtp] = useCreateCustomerOtpMutation();
  const [verifyOtp, { isLoading: verifyOtpLoading }] =
    useCustomerLoginMutation();
  const [placeOrder, { isLoading: placeOrderLoading }] =
    useCreateOrderMutation();
  const [checkItemAvailability, { isLoading: itemAvailabilityCheckLoading }] =
    useCheckFoodItemAvailabilityMutation();

  const handleGetOtp = async () => {
    //console.log(mobileNumber);
    if (mobileNumber?.length === 10) {
      //console.log("OTP sent");
      const resData = await generateOtp({ mobileNumber });
      toast.success("please enter OTP sent to your mobile number");
      setOtpSent(true);
      // alert("OTP sent to " + resData);
    } else {
      // console.log("Please enter valid mobileNumber");
      toast.error("Please enter valid mobileNumber");
    }
  };

  const takeToFoodListScreen = () => {
    setShowModal(false);
    navigate("/foodsList/" + userInfo?.openedOutletGroup);
  };

  // const grossTotal = selectedItems.reduce((total, item) => {
  //   const priceAfterPercentDiscount =
  //     item.itemOriginalPrice -
  //     (item.itemOriginalPrice * (item.discountPercent || 0)) / 100;

  //   const priceAfterAllDiscounts = Math.max(
  //     0,
  //     priceAfterPercentDiscount - (item.discountAmount || 0)
  //   );

  //   const totalBeforeTax = priceAfterAllDiscounts * item.quantity;

  //   const totalWithTax = totalBeforeTax * (1 + (item.gstTax || 0) / 100);

  //   return total + totalWithTax;
  // }, 0);

  // console.log("grossTotal");
  // console.log(grossTotal);

  const verifyOtpHandler = async () => {
    try {
      const resData = await verifyOtp({
        mobileNum: Number(mobileNumber),
        recentOTP: Number(getOtp),
      }).unwrap();

      if (resData?.token) {
        setOtpVerified(true);
        dispatch(setCredentials({ ...userInfo, token: resData?.token }));
      }
    } catch (e) {
      console.log("Error in verify otp", e);
      toast.error("OTP is not correct");
    }
  };

  const createOrder = async () => {
    const itemsAvailable = await checkItemAvailability(
      Object.values(userInfo?.selectedItems).map((item) => ({
        foodItemId: item.itemId,
        itemQuantity: item.selectedQuantity,
      }))
    ).unwrap();
    if (Object.keys(itemsAvailable).length === 0) {
      console.log("inside itemsAvailable === 0 ");
      // PAYMENT GATEWAY FUNCTION CALL COMES HERE. Place order will be called if payment was successfull.
      const orderResponse = await placeOrder({
        // mobileNumber,
        outletId: Object.values(userInfo?.selectedItems)[0].itemId.slice(0, 7),
        orderDetails: Object.values(userInfo?.selectedItems).map((item) => ({
          foodItemId: item.itemId,
          itemQuantity: item.selectedQuantity,
        })),
        deliverTo: userInfo?.deliveryTo?.includes("undefined")
          ? `${screen}, ${seatNumber}`
          : userInfo?.deliveryTo,
        // grossTotal: 525.05,
        grossTotal: (
          Object.values(selectedItems).reduce(
            (total, it) =>
              total +
              it.selectedQuantity * (it.itemOfferPrice - it.discountAmount) +
              (it.selectedQuantity *
                (it.itemOfferPrice - it.discountAmount) *
                it.gstPercent) /
                100,
            0
          ) +
          Object.values(selectedItems).reduce(
            (total, it) =>
              total +
              it.selectedQuantity * (it.itemOfferPrice - it.discountAmount) +
              (it.selectedQuantity *
                (it.itemOfferPrice - it.discountAmount) *
                it.gstPercent) /
                100,
            0
          ) *
            ((userInfo?.outletsDetails[0]?.companyId?.separatePlaformFee
              ? userInfo?.outletsDetails[0]?.companyId?.platformFee
              : 0) /
              100)
        ).toFixed(2),
        // grossTotal: grossTotal,
        token: userInfo?.token,
      }).unwrap();
      if (orderResponse) {
        toast.success("Order Placed Successfully");
        navigate("/orderConfirmation", {
          state: {
            orderResponse,
          },
        });
        dispatch(setCredentials({ ...userInfo, selectedItems: [] }));
        dispatch(setFoodList([]));
      } else {
        toast.error("Order Placement failed");
      }
    } else if (Object.keys(itemsAvailable).length > 0) {
      console.log("inside itemsAvailable > 0 ");
      console.log(itemsAvailable);
      setItemsForModal(
        Object.keys(itemsAvailable).map((it) => {
          return {
            fieldName: it,
            fieldType: "text",
            fieldValue: "only " + itemsAvailable[it] + " available",
            disabled: true,
          };
        })
      );
      // console.log("itemsForModal");
      // console.log(itemsForModal);
      setShowModal(true);
      setNotAvailableItems(itemsAvailable);
    }
  };

  return (
    <div>
      <FaArrowLeft
        onClick={() => navigate(-1)}
        className="back-arrow"
        style={{
          color: "green",
          marginRight: "1rem",
          fontSize: "1.8rem",
        }}
      />
      {showModal && (
        <ReUsableModal
          title="Oops..."
          restrictTitle="Food availability has changed. Please select items accordingly"
          payload={itemsForModal}
          show={showModal}
          size="md"
          onHide={takeToFoodListScreen}
          onSubmit={takeToFoodListScreen}
          submit="Okay"
          cancel="Go to Food List"
          submitDisabled={false}
          cancelDisabled={false}
        />
      )}

      <Row className="justify-content-center text-center">
        <Col md={6}>
          <h4 style={{ color: "black" }}>
            {userInfo?.outletsDetails &&
              userInfo?.outletsDetails[0]?.companyId?.companyName}
          </h4>
          <p className="login-subtitle">
            {userInfo?.outletsDetails &&
              userInfo?.outletsDetails[0]?.companyId?.companyCity}
          </p>

          {userInfo?.outletsDetails[0]?.companyId?.companyCategory?.toLowerCase() ===
            "theatre" &&
            !userInfo?.deliveryTo?.toLowerCase().includes("undefined") && (
              <h6 className="login-label">Seat - {userInfo?.deliveryTo}</h6>
            )}
          {!otpVerified && (
            <h5 className="login-label">Login with mobile number</h5>
          )}
          <Form.Control
            type="text"
            style={{ height: "3.5rem", fontSize: "1.3rem" }}
            placeholder="Enter mobile number"
            value={mobileNumber}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/\D/g, "");
              setMobileNumber(onlyNums);
            }}
            disabled={otpSent}
          />
          <br />
          {!otpSent ? (
            <Button style={{ height: "2.5rem" }} onClick={handleGetOtp}>
              Get OTP
            </Button>
          ) : (
            !otpVerified && (
              <>
                <Form.Control
                  style={{ height: "3.5rem", fontSize: "1.3rem" }}
                  type="text"
                  className="form-control mb-3 w-100 mx-auto"
                  placeholder="Enter OTP"
                  value={getOtp}
                  onChange={(e) => {
                    const onlyNums = e.target.value.replace(/\D/g, "");
                    setGetOtp(onlyNums);
                  }}
                />
                <br />
                <Button style={{ height: "2.5rem" }} onClick={verifyOtpHandler}>
                  Login
                </Button>
              </>
            )
          )}
          {otpVerified && (
            <>
              <br />
              {userInfo?.outletsDetails?.[0]?.companyId?.companyCategory?.toLowerCase() ===
                "theatre" &&
                userInfo?.deliveryTo?.includes("undefined") && (
                  <>
                    <Row className="mb-2">
                      <Col>
                        <Form.Label style={{ color: "black" }}>
                          Enter Screen and Seat Number (Optional)
                        </Form.Label>
                      </Col>
                    </Row>
                    <Row className="mb-3 justify-content-center">
                      <Col>
                        <Form.Control
                          style={{ height: "3.5rem", fontSize: "1.3rem" }}
                          type="text"
                          placeholder="Screen"
                          value={screen}
                          onChange={(e) => setScreen(e.target.value)}
                        />
                      </Col>
                      <Col>
                        <Form.Control
                          style={{ height: "3.5rem", fontSize: "1.3rem" }}
                          type="text"
                          placeholder="Seat Number"
                          value={seatNumber}
                          onChange={(e) => setSeatNumber(e.target.value)}
                        />
                      </Col>
                    </Row>
                  </>
                )}
              <br />
              <br />
              <h6 style={{ color: "black" }}>
                Total : ₹{" "}
                {(selectedItems !== null || selectedItems !== undefined) &&
                  (
                    Object.values(selectedItems)?.reduce(
                      (total, it) => total + it.totalSellingPrice,
                      0
                    ) +
                    Object.values(selectedItems)?.reduce(
                      (total, it) => total + it.totalSellingPrice,
                      0
                    ) *
                      ((userInfo?.outletsDetails[0]?.companyId
                        ?.separatePlaformFee
                        ? userInfo?.outletsDetails[0]?.companyId?.platformFee
                        : 0) /
                        100)
                  ).toFixed(2)}{" "}
              </h6>

              <Button onClick={createOrder} className="login-button">
                Pay Now
              </Button>
            </>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default FoodAppLoginScreen;
